/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { EyeIcon } from "lucide-react";
import { Link } from "react-router-dom";

export const ViewButton = ({ row, onAction }: any) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {row.originData?.has_child ? (
          <Button
            variant={"ghost"}
            size={"icon"}
            className="text-primary"
            onClick={() => {
              onAction({ data: row.originData, action: "view" });
            }}
          >
            <EyeIcon />
          </Button>
        ) : (
          <Link
            to={`/document/details/${row?.originData?.doc_id}`}
            className=" inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9 text-primary"
          >
            <div>
              <EyeIcon size={16} />
            </div>
          </Link>
        )}
      </TooltipTrigger>

      <TooltipContent>
        <p>{row.originData?.has_child ? "View All" : "View"}</p>
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
